<template lang="pug">
  include ./../../mixins
  +b.order.--checkout
    +b.H2.caption.--size_2 {{ _("Checkout Form") }}
    +e.content
      +b.P.caption.--size_3.--color_red {{ _("Prepayment:") }}
        | 
        span {{ orderInfo.prepayment }}
      +b.P.text.--fs_md.--color_black {{ _("Final Payment:") }}
        | 
        +b.SPAN.text.--fs_md.--color_black.--fw_bold {{ finalPayment }}
      +b.P.text.--fs_md.--color_black {{ _("Total Price:") }}
        | 
        +b.SPAN.text.--fs_md.--color_black.--fw_bold {{ orderInfo.price }}
      +b.P.text.--fw_bold.--fs_xl.--color_black {{ _("Order details:") }}
      +b.P.text.--fs_md.--color_black {{ _("Date:") }}
        | 
        +b.SPAN.text.--fs_md.--color_black.--fw_bold(v-if="orderInfo.dateAt") {{ orderInfo.dateAt.split('T')[0] }}
      +b.P.text.--fs_md.--color_black {{ _("Time:") }}
        | 
        +b.SPAN.text.--fs_md.--color_black.--fw_bold(v-if="orderInfo.dateAt") {{ orderInfo.dateAt.split('T')[1].split('Z')[0] }}
      div(v-if="orderInfo.service_detail")
        +b.P.text.--fs_md.--color_black {{ _("Selected service:") }}
          | 
          +b.SPAN.text.--fs_md.--color_black.--fw_bold
        +b.P.text.--fs_md.--color_black.--fw_bold {{ orderInfo.service_detail.title }}
        +b.P.text.--fs_md.--color_black(v-html="orderInfo.service_detail.description")
    +e.content
      validation-observer(
        tag="form"
        ref="observer"
        v-slot="props"
        @submit.prevent="validateBeforeSubmit"
      )
        +b.ug-row.--offset_sm
          +b.ug-cell.ug-cols
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="name"
            )
              ui-input.control--xl(
                v-model='formdata.name',
                type='text',
                :errors="errors"
                :label='_("Full Name")'
              )
          +b.ug-cell.ug-cols.--6-sm
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="car_registration"
            )
              ui-input.control--xl(
                v-model='formdata.car_registration',
                type='text',
                :errors="errors"
                :label='_("Car registration number")'
              )
          +b.ug-cell.ug-cols.--6-sm
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="phone"
            )
              ui-input.control--xl(
                v-model='formdata.phone',
                type='text',
                :errors="errors"
                :label='_("Phone")'
              )
          +b.ug-cell.ug-cols.--6-sm
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="address"
            )
              ui-input.control--xl(
                v-model='formdata.address',
                type='text',
                :errors="errors"
                :label='_("Address")'
              )
          +b.ug-cell.ug-cols.--6-sm
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="post_code"
            )
              ui-input.control--xl(
                v-model='formdata.post_code',
                type='text',
                :errors="errors"
                :label='_("Postal code (where to drive)")'
              )
          +b.ug-cell.ug-cols
            +b.ug-row.--offset_sm
              +b.ug-cell.ug-cols
                file-uploader#upload(
                  :max-files='5'
                  :multiple-files='true'
                  accepted-files='.jpg, .jpeg, .png'
                  :max-size='10'
                  @files-change='filesChange')
                  template(slot='info' slot-scope='{ maxFiles, maxSize,  acceptedFiles}')
                    .upload__info
                      +b.SPAN.text ({{ _("Maximum number of files - ") }} {{ maxFiles }}, 
                      +b.SPAN.text {{ _("maximum file size - ") }} {{ maxSize }} {{ _("MB") }}, 
                      +b.SPAN.text {{ _("allowed formats - ") }} {{ acceptedFiles }})
                  template(slot='filesName' slot-scope='{ filesName, index }')
                    span {{filesName[index]}}
                  template(slot="button")
                    +b.upload__button
                      +b.button.--height_xl.--bg_transparent.--border_common
                        +e.icon
                          +b.I.icon.--type_attach
                        +e.SPAN.text {{ _("Attach files") }}
                  template(slot="remove")
                    +b.I.icon.--type_close       
        
        validation-provider.mt-20(
          tag="div"
          v-slot="{errors}"
          :rules="{ required: { allowFalse: false } }"
          name="terms"
        )
          +b.checkbox-wrapper
            +e.body
              +b.LABEL.control-checkbox
                +e.INPUT.element(type='checkbox' v-model="terms")
                +e.SPAN.label
            +e.content
              +b.P.text.--color_black.--lh_xxs {{ _("I agree with") }}
                | 
                +b.A.link(:href="termsPageUrl" target="_blank") {{ _("Terms and Conditions") }}
          +b.P.help.--type_error(:class='{"is-error": errors[0]}') {{ errors[0] }}
        validation-provider.mt-20(
          tag="div"
          v-slot="{errors}"
          name="detail"
        )
          +b.P.help.--type_error(v-if="errors[0]" :class='{"is-error": errors[0]}') {{ errors[0] }}
        +e.content
          +b.ug-row.--offset_sm.--alignment_center
            +b.ug-cell.ug-cols.--6-sm
              +b.P.text {{ _("This link will expire in two hours, so please dont postpone your payment") }}
            +b.ug-cell.ug-cols.--6-sm(v-if="!paymentIsAllowed")
              +b.A.button(@click.prevent="validateBeforeSubmit") {{ _("Prepayment") }} {{ orderInfo.prepayment }}
          .js-paypal.paypal-buttons(v-show="paymentIsAllowed")
</template>

<script>
import mixinValidate from '@/js/mixins/formValidate'
import mixinErrors from '@/js/mixins/showErrors'

import InfoModal from '@/js/components/Modals/InfoModal'

export default {
  props: {
    uuid: String,
    termsPageUrl: String,
    successUrl: String,
    objectData: {},
  },
  mixins: [
    mixinValidate,
    mixinErrors,
  ],
  data() {
    return {
      terms: false,
      orderInfo: {},
      formdata: {
        name: null,
        'car_registration': null,
        phone: null,
        address: null,
        'post_code': null,
      },
      paymentIsAllowed: false,
    }
  },
  async mounted() {
    await this.preparedData()
    this.getOrderInfo()
    this.initPaypal()
  },
  computed: {
    finalPayment() {
      return parseInt(this.orderInfo.price) - 
        parseInt(this.orderInfo.prepayment)
    }
  },
  methods: {
    initPaypal() {
      paypal.Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            'purchase_units': [{
              amount: {
                value: this.orderInfo.prepayment,
              }
            }]
          }).then(res => {
            let url = '/api/v1/order/create-pay/'
            let formdata = {
              id: res
            }
            this.api.post(url, formdata).then(() => {
              console.log('Create Order Post')
            })
            return res
          })
        },
        onApprove: (data, actions) => {
          return actions.order.capture().then(details => {
            let orderID = data.orderID
            let url = '/api/v1/order/check-pay/'
            let formdata = {
              id: orderID
            }
            this.api.post(url, formdata).then((res) => {
              console.log(res)
              console.log('onApprove')
              this.showSuccessModal()
              window.location = this.successUrl
            })
          }).then(details => {
            if ('INSTRUMENT_DECLINED' === details.error) {
              console.log(details)
              return actions.restart()
            }
          })
        },
        onError: (err) => {
          console.log(err)
        },
        onCancel: (data, actions) => {
          console.log(data, actions)
        },
      }).render('.js-paypal')
    },
    getOrderInfo() {
      this.api.get(`/api/v1/order/${this.uuid}/receive/`).then(res => {
        console.log(res)
        let {data} = res
        this.orderInfo = data
      })
    },
    filesChange() {
      let files = document.querySelector('input[type="file"]').files
      this.formdata.attachments = []
      Array.from(files).forEach(el => {
        this.formdata.attachments.push(el)
      })
    },
    send() {
      let formData = new FormData()
      let arr = Object.keys(this.formdata)
      let zero = 0
      formData = new FormData()
      arr.forEach((element, index) => {
        if (Array.isArray(this.formdata[element]) 
          && this.formdata[element].length > zero) {
          this.formdata[element].forEach((el, i) => {
            formData.append(`${element}_${i}`, this.formdata[element][i])
          })
        } else {
          formData.append(element, this.formdata[element])
        }
      })
      this.api.patch(`/api/v1/order/${this.uuid}/pay/`, formData).then(res => {
        this.paymentIsAllowed = true
      }).catch(error => {
        let {data} = error.response
        this.showErrors(data)
      })
    },

    scrollToFirstError() {
      let firstElOfError = document.querySelector('.help--type_error')
      if (firstElOfError) {
        let offset = (el) => {
          let rect = el.getBoundingClientRect(),
            scrollTop = window.pageYOffset ||
              document.documentElement.scrollTop
          return rect.top + scrollTop
        }
        let errorParent = firstElOfError.closest('.control')
        let offsetEl = offset(errorParent)
        this.scrollToTop(window, 'scrollTo', offsetEl)
      }
    },
    scrollToTop(element, method, offset) {
      element[method]({
        top: offset,
        behavior: 'smooth'
      })
    },
    showSuccessModal() {
      this.$modal.show(InfoModal, {
        title: this._("Order successfully created."),
      }, {
        height: 'auto',
        transition: "nice-modal-fade",
        clickToClose: false,
        scrollable: true
      })
    },
    preparedData() {
      Object.keys(this.objectData).forEach(el => {
        this.formdata[el] = this.objectData[el]
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Order/Checkout.vue